//saved item add to cart
function addToCart(productId, element) {
  event.preventDefault(); // Prevent link behavior

  const quantity = parseInt(element.getAttribute('data-qty')) || 1; // fallback to 1 if not found

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: productId, quantity: quantity })
  })
  .then(response => response.json())
  .then(data => {
    console.log('Added to cart:', data);
    alert(`Added ${quantity} item(s) to cart!`);
  })
  .catch(error => console.error('Error adding to cart:', error));
}

function updateQty(button, change) {
    let input = button.closest('form').querySelector('.qty-input');
    let newValue = parseInt(input.value) + change;
    if (newValue > 0) {
        input.value = newValue;
    }
}

//OM QTY input
      document.addEventListener('DOMContentLoaded', function() {
          // Use delegation in case DOM updates later
          document.body.addEventListener('click', function(event) {
              if (event.target.classList.contains('qty-btn')) {
                  const button = event.target;
                  const selector = button.closest('.quantity-selector');
                  const input = selector.querySelector('.qty-input');
                  const om = parseInt(selector.dataset.om, 10) || 1;
                  const isPlus = button.textContent.trim() === '+';

                  const currentQty = parseInt(input.value, 10) || om;
                  let newQty = currentQty + (isPlus ? om : -om);
                  if (newQty < om) newQty = om;

                  // Clear visually, then set new value with short delay
                  input.value = '';
                  setTimeout(() => {
                      input.value = newQty;
                  }, 10);
              }
          });

          // Disable manual input on load
          document.querySelectorAll('.qty-input').forEach(input => {
              const om = parseInt(input.closest('.quantity-selector')?.dataset.om, 10) || 1;

              input.value = om;
              input.min = om;
              input.step = om;

              input.addEventListener('keydown', e => e.preventDefault());
              input.addEventListener('paste', e => e.preventDefault());
              input.addEventListener('input', e => {
                  e.target.value = om;
              });
          });
      });

//back link
 document.addEventListener('DOMContentLoaded', function () {
    const referrer = document.referrer;
    const validReferrer = referrer.includes('/collections') || referrer.includes('/search') || referrer.includes('/pages');

    if (validReferrer) {
      const container = document.getElementById('back-link-container');
      if (container) {
        const link = document.createElement('a');
        link.href = referrer;
        link.textContent = '← Back to List';
        link.className = 'back-link';
        container.appendChild(link);
      }
    }
  });